<bit-section>
  <bit-section-header>
    <h2 bitTypography="h6">{{ "itemHistory" | i18n }}</h2>
  </bit-section-header>
  <bit-card>
    <p class="tw-mb-1 tw-text-xs tw-text-muted tw-select-none">
      <span class="tw-font-bold">{{ "lastEdited" | i18n }}:</span>
      {{ cipher.revisionDate | date: "medium" }}
    </p>
    <p
      class="tw-text-xs tw-text-muted tw-select-none"
      [ngClass]="{
        'tw-mb-1 ': cipher.hasPasswordHistory && isLogin,
        'tw-mb-0': !cipher.hasPasswordHistory || !isLogin,
      }"
    >
      <span class="tw-font-bold">{{ "dateCreated" | i18n }}:</span>
      {{ cipher.creationDate | date: "medium" }}
    </p>
    <p
      *ngIf="cipher.hasPasswordHistory && isLogin"
      class="tw-text-xs tw-text-muted tw-select-none"
      [ngClass]="{ 'tw-mb-3': cipher.hasPasswordHistory }"
    >
      <span class="tw-font-bold">{{ "datePasswordUpdated" | i18n }}:</span>
      {{ cipher.passwordRevisionDisplayDate | date: "medium" }}
    </p>
    <button
      *ngIf="cipher.hasPasswordHistory && isLogin"
      (click)="viewPasswordHistory()"
      bitTypography="body2"
      bitLink
      type="button"
    >
      {{ "passwordHistory" | i18n }}
    </button>
  </bit-card>
</bit-section>
